export const networks = {
    mainnet: {
      name: "mainnet",
      rpcUrl: "https://mainnet.infura.io/v3/7bdf8cedd4ac4e6c897a21f21dca6ceb",
      blockExplorerUrl: "https://etherscan.io/address/",
    },
    holesky: {
      name: "holesky",
      rpcUrl: "https://holesky.infura.io/v3/7bdf8cedd4ac4e6c897a21f21dca6ceb",
      blockExplorerUrl: "https://holesky.etherscan.io/address/",
    },
    sepolia: {
        name: "sepolia",
        rpcUrl: "https://sepolia.infura.io/v3/7bdf8cedd4ac4e6c897a21f21dca6ceb",
        blockExplorerUrl: "https://sepolia.etherscan.io/address/",
    },

    // Add more networks as needed
  };